import { render, staticRenderFns } from "./SearchMKB10.vue?vue&type=template&id=4dd9c984&scoped=true"
import script from "./SearchMKB10.vue?vue&type=script&lang=js"
export * from "./SearchMKB10.vue?vue&type=script&lang=js"
import style0 from "./SearchMKB10.vue?vue&type=style&index=0&id=4dd9c984&prod&scoped=true&lang=css"
import style1 from "./SearchMKB10.vue?vue&type=style&index=1&id=4dd9c984&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd9c984",
  null
  
)

export default component.exports